import { render } from "./VehiclePriceHistory.vue?vue&type=template&id=67a5ce01&scoped=true"
import script from "./VehiclePriceHistory.vue?vue&type=script&lang=js"
export * from "./VehiclePriceHistory.vue?vue&type=script&lang=js"

import "./VehiclePriceHistory.vue?vue&type=style&index=0&id=67a5ce01&lang=scss&scoped=true"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5ce01"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSkeleton,QIcon});
